module.exports = __webpack_public_path__ + "static/img/jps.4417bf1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/course/jps.jpg
// module id = msxD
// module chunks = 0